import fetch from "../utils/fetch";

const baseUrl = "";

// 快速检索列表
export function getQuickList(data) {
  return fetch({
    url: baseUrl + "/record_of_search/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 新增快速检索
export function addQuick(data) {
  return fetch({
    url: baseUrl + "/api/add_quick_search",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 删除快速检索
export function removeQuick(data, id) {
  return fetch({
    url: baseUrl + `/record_of_search/${id}/`,
    method: "PATCH",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 联想搜索
export function searchOptions(data) {
  return fetch({
    url: baseUrl + "/api/search_options",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 综合搜索
export function searchAll(data) {
  return fetch({
    url: baseUrl + "/api/search",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 搜索文件类数据列表
export function searchFileList(data) {
  return fetch({
    url: baseUrl + "/api/specific_search",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 文件下载数量限制
export function fileDownloadSize(data) {
  return fetch({
    url: baseUrl + "/api/users/company_download_record",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}


// 创建订单
export function createOrder(data) {
  return fetch({
    url: "/order/create_order/",
    method: "post",
    data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取文件详情
export function getFileStatus(data) {
  return fetch({
    url: "/order/retrive_file_status/",
    method: "post",
    data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 用户、公司翻译明细
export function getOrderList(data) {
  return fetch({
    url: "/order/list_order/",
    method: "post",
    data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}